/**
 * Shared layout tokens and breakpoints.
 * Page and wide screens use the full viewport; forms and dialogs stay constrained.
 */
export const breakpoints = {
  tablet: 768,
  laptop: 1024,
  desktop: 1280,
} as const;

export const layout = {
  /** Legacy reading-width tokens (page/wide screens are full-view). */
  webPageMaxWidth: 960,
  tabletPageMaxWidth: 720,
  desktopPageMaxWidth: 1120,
  /** Legacy wide tokens (calendars and boards are full-view). */
  webWideMaxWidth: 1200,
  tabletWideMaxWidth: 960,
  desktopWideMaxWidth: 1440,
  /** Login and other narrow auth forms. */
  webFormMaxWidth: 440,
  /** Centered dialogs converted from mobile bottom sheets. */
  webModalMaxWidth: 480,
  /** Full-screen task/create flows shown as dialogs on web / tablet+. */
  webDialogMaxWidth: 720,
  webDrawerMaxWidth: 360,
  /** Web: readable cap for standard pages inside the sidebar shell. */
  webContentMaxWidth: 1280,
  /** Web: data-entry forms, filters, and settings. */
  webNarrowContentMaxWidth: 880,
  /** Web: cap for calendars, boards, and report tables. */
  webWideContentMaxWidth: 1760,
  /** Web: expanded sidebar (laptop / desktop) and collapsed rail (tablet). */
  webSidebarWidth: 248,
  webSidebarRailWidth: 96,
} as const;

/**
 * page: standard screens; wide: calendars, boards, report tables;
 * narrow: data-entry forms, filters, settings (web only, page on native);
 * form: narrow auth column; fluid: full viewport.
 */
export type WebLayout = 'page' | 'wide' | 'narrow' | 'form' | 'fluid';
export type FormFactor = 'mobile' | 'tablet' | 'laptop' | 'desktop';
